import { activePage } from "../native/pages";
import type { NativeFrame, NativeRenderer } from "./native-port";
/** Selection/tool chrome is a separate surface; it does not invalidate scene pixels. */
export class NativeScenePainter {
  private previous: unknown[] = [];
  draws = 0;
  skipped = 0;
  draw(
    renderer: NativeRenderer,
    frame: NativeFrame,
    resources: number,
    fonts: number,
  ) {
    const p = activePage(frame.document);
    const key = [
      renderer,
      p.nodes,
      frame.document.assets,
      p.size.width,
      p.size.height,
      p.backgroundVisible,
      p.workspaceColor,
      frame.workspaceGrid?.enabled,
      frame.workspaceGrid?.color,
      frame.workspaceGrid?.opacity,
      frame.camera.x,
      frame.camera.y,
      frame.camera.zoom,
      frame.width,
      frame.height,
      frame.dpr,
      resources,
      fonts,
    ];
    if (key.every((value, i) => value === this.previous[i])) {
      this.skipped++;
      return;
    }
    renderer.draw(frame);
    this.previous = key;
    this.draws++;
  }
}
